require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./keyword-cloud-service-api.json") })
        }
      }, "path---keyword-cloud-service-api");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---keyword-cloud-service-api!./.cache/json/keyword-cloud-service-api.json
// module id = 691
// module chunks = 231608221292675